import moment from 'moment';

// Helper to format date with conditional year logic
const formatDateConditionalYear = (
	date,
	withTime = false,
	dateType = 'unix',
	alwaysIncludeYear = false
) => {
	const m = dateType === 'unix' ? moment.unix(date) : moment(date);
	const now = moment();
	if (alwaysIncludeYear || m.year() !== now.year()) {
		return withTime
			? m.format('ll, LT')
			: m.format('ll');
	} else {
		return withTime ? m.format('LTS, LT') : m.format('LTS');
	}
};

const formatDate = ({
	date,
	platform = 'stripe',
	short = false,
	alwaysIncludeYear = false,
}) => {
	const dateType = platform === 'runner' ? 'mongo' : 'unix';
	return formatDateConditionalYear(date, !short, dateType, alwaysIncludeYear);
};

export { formatDate };
